import { Box, styled, Tab as MuiTab, Tabs as MuiTabs } from '@mui/material'

export const TabsContainer = styled(Box)(({ theme }) => ({
	borderBottom: `1px solid ${theme.palette.divider}`,
	width: '100%',
}))

export const StyledTabs = styled(MuiTabs)(({ theme }) => ({
	'& .MuiTabs-indicator': {
		height: 2,
		backgroundColor: theme.palette.primary.main,
	},
}))

export const StyledTab = styled(MuiTab)({
	minWidth: 'auto',
	padding: '12px 16px',
})
